import { Trans } from "@lingui/react/macro";
import { Button, Link } from "@heroui/react";
import { ArrowLeft } from "lucide-react";
import { FaApple, FaGooglePlay } from "react-icons/fa";
import {
  CUSTOMER_APP_STORES,
  CUSTOMER_MARKETPLACE_URL,
  detectDevicePlatform,
  getCustomerAppStores,
} from "./registerRole";

/**
 * Shown to someone looking for a salon. A phone is usually sent straight to
 * its store before this renders; it stays as the fallback when that redirect
 * is blocked, and as the only path on desktop, where both stores are offered.
 */
export function CustomerAppDownload({ onBack }: { onBack: () => void }) {
  const stores = getCustomerAppStores(detectDevicePlatform());

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-1 text-center">
        <p className="font-semibold text-lg">
          <Trans>Prenesite aplikacijo Lime Booking</Trans>
        </p>
        <p className="text-default-500 text-sm">
          <Trans>
            Storitve in proste termine poiščete v naši aplikaciji za stranke.
          </Trans>
        </p>
      </div>

      <div className="flex flex-col gap-2 sm:flex-row">
        {stores.includes("appStore") && (
          <Button
            as={Link}
            href={CUSTOMER_APP_STORES.appStore}
            isExternal
            color="primary"
            className="w-full"
            startContent={<FaApple size={18} />}
            data-identifier="customer-app-store-link"
          >
            <Trans>Prenesi v App Store</Trans>
          </Button>
        )}

        {stores.includes("googlePlay") && (
          <Button
            as={Link}
            href={CUSTOMER_APP_STORES.googlePlay}
            isExternal
            color="primary"
            className="w-full"
            startContent={<FaGooglePlay size={16} />}
            data-identifier="customer-google-play-link"
          >
            <Trans>Prenesi v Google Play</Trans>
          </Button>
        )}
      </div>

      <Link
        href={CUSTOMER_MARKETPLACE_URL}
        isExternal
        showAnchorIcon
        size="sm"
        className="self-center"
        data-identifier="customer-marketplace-link"
      >
        <Trans>Ali poiščite salon v brskalniku</Trans>
      </Link>

      <Button
        variant="light"
        onPress={onBack}
        startContent={<ArrowLeft size={16} />}
      >
        <Trans>Nazaj</Trans>
      </Button>
    </div>
  );
}
